<div class="card-grouping">
  <div class="card-count" [ngbTooltip]="tooltipText" (click) = "onClick()" *ngIf="showToggleIcon || groupCardHeader">
    <span ><i class="fa " [ngClass]="headerIcon" aria-hidden="true"></i></span>
    <span *ngIf="groupCardHeader" class="grouped-header cursor-pointer semi-bold">
      {{ groupCardHeader }}
    </span>
    <div class="spacer"></div>
    <span class="fa fa-chevron-right"></span>
  </div>

  <div class="card-container" [ngClass]="chartType === 'bar'? 'pl-0' : ''" *ngIf="showCards">
    <ng-content></ng-content>
  </div>
</div>
